module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/27f90bfa982840e56c3ad207561193fa.svg";